import { shape, string,  number } from "prop-types"

export const ExpenseShape = shape({
    expenseId: string.isRequired,
    status: number.isRequired
})